import { IconButton, Tooltip } from '@mui/material';
import { Bot } from 'lucide-react';
import { useOptionalAdminAgentDrawer } from '../context/AdminAgentDrawerContext';

/** Opens/closes the assistant drawer. Hidden once the feature turns out to be unavailable. */
export const AdminAgentToggleButton: React.FC = () => {
  const drawer = useOptionalAdminAgentDrawer();
  if (!drawer || drawer.sessionState === 'unavailable') return null;
  const { open, toggle } = drawer;

  const label = open ? 'Close admin assistant' : 'Open admin assistant';
  return (
    <Tooltip title={label} placement="bottom">
      <IconButton
        onClick={toggle}
        size="small"
        aria-label={label}
        aria-pressed={open}
        className={
          open
            ? 'bg-blue-50 text-blue-600 dark:bg-slate-700 dark:text-blue-400'
            : 'text-gray-600 hover:bg-gray-100 dark:text-slate-400 dark:hover:bg-slate-700'
        }
      >
        <Bot size={20} />
      </IconButton>
    </Tooltip>
  );
};
